import React, { Component } from 'react'
import { TextInput } from '../shared/TextInput'
import _ from 'lodash'

export default class DateLimit extends Component {
  render() {
    return (
      <div style={{ marginTop: 30 }}>
        <div>
          <TextInput
            questionMark={ true }
            dataTip={ 'How far out can customers reserve Future Inventory in days?' }
            inputName='futureDateLimit'
            label='Future Inventory Date Limit'
            placeholderText='Days out'
          />
        </div>
          <TextInput
            questionMark={ true }
            dataTip={ 'How far out can customers reserve Available Inventory in days?' }
            inputName='availableDateLimit'
            label='Available Inventory Date Limit'
            placeholderText='Days out'
          />
          <TextInput
            questionMark={ true }
            dataTip={ 'How far out can customers select a return date in days?' }
            inputName='returnDateLimit'
            label='Return Date Limit'
            placeholderText='Days out'
          />
          <TextInput
            questionMark={ true }
            dataTip={ 'How long after the expected return date should we charge the deposit in days?' }
            inputName='chargeDepositDateLimit'
            label='Days until Deposit is charged'
            placeholderText='Days out'
          />
          <TextInput
            questionMark={ true }
            dataTip={ "Do you have a minimum reservation period? Set that here. i.e. don't accept reservations for how many days?" }
            inputName='waitForReservations'
            label="Days until accepting Reservations"
            placeholderText='Days out'
          />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Settings/DateLimit.jsx